import {get, post, listAll} from '../utils';

const dao = {
  listAllPayouts: async params => await listAll(dao.listPayouts, params),
  listPayouts: async () =>
    await get('/smb-backend/partner/finance/list-payouts.action'),
  createPayout: async params =>
    await post('/smb-backend/partner/finance/create-payout.action', params),
  queryStats: async () =>
    await get('/smb-backend/partner/finance/query-stats.action'),
};

export default dao;
